module.exports = __webpack_public_path__ + "assets/img/voice-start.8687c991.png";